import { get } from 'lodash';
import * as Timestamps from '@/types/timestamp';
import moment from 'moment';

/*
  Settlements are here: /api/v1/companyDashboard/{companyId}/loadSettlements
  Here is a sample response object.

  {
     "payables": [
        {
            "amount": 4500.0,
            "billOfLading": {
                "contentType": null,
                "link": null,
                "name": null,
                "status": "MISSING"
            },
            "billOfLadingNumber": null,
            "billedToCompanyId": "1050",
            "billedToCompanyName": "RossCo Carriers",
            "canceled": null,
            "delivered": null,
            "description": "Dispatched Load Freight Bill",
            "id": 5471719615627264,
            "invoiceAmount": null,
            "invoiceNumber": null,
            "invoiced": null,
            "invoicedByDisplayName": null,
            "invoicedByUserId": null,
            "loadHumanId": "RC-L1007",
            "loadStatus": "SCHEDULED",
            "paidToCompanyId": "1052",
            "paidToCompanyName": "SchultzCo Inc",
            "pickedUp": null,
            "pickup": "2018-12-21T14:00:00-07:00",
            "status": "OPEN"
        }
    ],
    "receivables": [
        {
            "amount": 350.0,
            "billOfLading": {
                "contentType": "application/pdf",
                "link": null,
                "name": "Bill of Lading/Docket for Load RC-L1025",
                "status": "PROCESSING"
            },
            "billOfLadingNumber": null,
            "billedToCompanyId": "1052",
            "billedToCompanyName": "SchultzCo Inc",
            "canceled": null,
            "delivered": null,
            "description": "Dispatched Load Freight Bill",
            "id": 4537684487831552,
            "invoiceAmount": null,
            "invoiceNumber": null,
            "invoiced": null,
            "invoicedByDisplayName": null,
            "invoicedByUserId": null,
            "loadHumanId": "SI-L1002",
            "loadStatus": "SETTLEMENT",
            "paidToCompanyId": "1050",
            "paidToCompanyName": "RossCo Carriers",
            "pickedUp": null,
            "pickup": "2018-12-20T10:00:00-07:00",
            "status": "OPEN"
        }
    ]
  }

 */

const loadNumber = (settlement, defalt) => get(settlement, 'loadHumanId', defalt);
const loadGroupNumber = (settlement, defalt) => get(settlement, '', defalt);
const loadStatus = (settlement, defalt) => get(settlement, 'status', defalt);
const pickedUp = settlement => get(settlement, 'pickedUp');
const scheduledPickup = settlement => get(settlement, 'pickup');
const canceled = settlement => get(settlement, 'canceled');
const delivered = settlement => get(settlement, 'delivered');

const billedTo = (settlement) => {
  const companyId = get(settlement, 'billedToCompanyId');
  const name = get(settlement, 'billedToCompanyName');

  return {
    id: companyId,
    name,
    companyId,
    companyName: name,
  };
};

const paidTo = (settlement) => {
  const companyId = get(settlement, 'paidToCompanyId');
  const name = get(settlement, 'paidToCompanyName');

  return {
    id: companyId,
    name,
    companyId,
    companyName: name,
  };
};

export const id = settlement => settlement.id;
export const description = settlement => get(settlement, 'description');
export const status = settlement => get(settlement, 'status');
export const amount = settlement => get(settlement, 'amount');

export const load = settlement => ({
  id: loadNumber(settlement),
  group: loadGroupNumber(settlement),
  status: loadStatus(settlement),
  pickedUp: pickedUp(settlement),
  scheduledPickup: scheduledPickup(settlement),
  canceled: canceled(settlement),
  delivered: delivered(settlement),
});

export const billOfLading = settlement => ({
  number: get(settlement, 'billOfLadingNumber'),
  ...get(settlement, 'billOfLading'),
});

export const invoice = settlement => ({
  amount: settlement.invoiceAmount,
  number: settlement.invoiceNumber,
  created: settlement.invoiced,
  createdBy: settlement.invoicedByDisplayName,
  createdByUserId: settlement.invoicedByUserId,
  billedTo: billedTo(settlement),
  paidTo: paidTo(settlement),
});

// not sure I need to do this.  but.
export default {
  invoice,
  delivered,
};



// WEBPACK FOOTER //
// ./src/types/models/settlement.js